"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var RenderProps = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _Functions = require("../core/Functions");

var activeContextValue = {
  transitioning: true
};
var inactiveContextValue = {
  transitioning: false
};

var getContextValue = function getContextValue(transitioning) {
  return transitioning ? activeContextValue : inactiveContextValue;
};

var TwoWayTransition =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TwoWayTransition, _React$Component);

  function TwoWayTransition(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TwoWayTransition);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TwoWayTransition).call(this, props));
    var children = props.children,
        transitionOnMount = props.transitionOnMount;
    _this.state = {
      cachedChildren: children,
      hidden: transitionOnMount ? children != null : children == null,
      transitioning: false,
      transitionActive: false,
      opening: false,
      closing: false
    };
    _this.stopTransition = _this.stopTransition.bind((0, _assertThisInitialized2.default)(_this));
    _this._t = 0;
    return _this;
  }

  (0, _createClass2.default)(TwoWayTransition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      var _this$props = this.props,
          children = _this$props.children,
          duration = _this$props.duration,
          onOpenStart = _this$props.onOpenStart,
          onOpenComplete = _this$props.onOpenComplete,
          transitionOnMount = _this$props.transitionOnMount;

      if (transitionOnMount) {
        this.startTransition(children == null, duration);
      } else if (children != null) {
        (0, _Functions.callIfPossible)(onOpenStart);
        (0, _Functions.callIfPossible)(onOpenComplete);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          children = _this$props2.children,
          duration = _this$props2.duration,
          transitionOnUpdate = _this$props2.transitionOnUpdate; // ⚠️ This condition prevents infinite loops! ⚠️

      if (prevProps.children === children) return;

      if (children != null) {
        this.cacheChildren(children);
      }

      if (transitionOnUpdate) {
        if (prevProps.children == null && children != null) {
          this.startTransition(false, duration);
        } else if (prevProps.children != null && children == null) {
          this.startTransition(true, duration);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      cancelAnimationFrame(this._frame);
    }
  }, {
    key: "cacheChildren",
    value: function cacheChildren(children) {
      if (children === this.state.cachedChildren) return;
      this.setState({
        cachedChildren: children
      });
    }
  }, {
    key: "startTransition",
    value: function startTransition(hidden, duration) {
      var _this2 = this;

      var _this$props3 = this.props,
          onOpenStart = _this$props3.onOpenStart,
          onCloseStart = _this$props3.onCloseStart;

      if (hidden) {
        (0, _Functions.callIfPossible)(onCloseStart);
      } else {
        (0, _Functions.callIfPossible)(onOpenStart);
      } // Clear any other pending timers on the component


      cancelAnimationFrame(this._frame);
      clearTimeout(this._timeout); // If duration={0}, skip the CSS transition entirely (#6542)

      if (duration === 0) {
        this.setState({
          hidden: hidden
        });
        this.stopTransition(hidden);
        return;
      } // Edge case: If startTransition() is called again before the setState() callback fires, abort.


      this._t += 1;
      var setStateHandle = this._t;
      this.setState({
        transitioning: true
      }, function () {
        if (setStateHandle !== _this2._t) return; // Normally, two RAFs are the correct amount of time to wait before applying style changes to
        // trigger a transition. However, we need three to allow React changes to flush to the DOM.

        _this2._frame = requestAnimationFrame(function () {
          _this2._frame = requestAnimationFrame(function () {
            _this2._frame = requestAnimationFrame(function () {
              if (!_this2._isMounted) return;

              _this2.setState({
                hidden: hidden,
                closing: hidden,
                opening: !hidden,
                transitionActive: true
              });

              _this2._timeout = setTimeout(_this2.stopTransition, duration);
            });
          });
        });
      });
    }
  }, {
    key: "stopTransition",
    value: function stopTransition(forceHidden) {
      var _this$props4 = this.props,
          onOpenComplete = _this$props4.onOpenComplete,
          onCloseComplete = _this$props4.onCloseComplete;
      var hidden = this.state.hidden; // In the duration={0} scenario, state has not yet flushed, so we pass it explicitly.

      var computedHidden = forceHidden != null ? forceHidden : hidden;
      if (computedHidden) (0, _Functions.callIfPossible)(onCloseComplete);
      if (!this._isMounted) return;
      if (!computedHidden) (0, _Functions.callIfPossible)(onOpenComplete);
      this.setState({
        transitioning: false,
        transitionActive: false
      });

      if (computedHidden) {
        this.cacheChildren(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          ContextProvider = _this$props5.ContextProvider,
          __onOpenStart = _this$props5.onOpenStart,
          __onOpenComplete = _this$props5.onOpenComplete,
          __onCloseStart = _this$props5.onCloseStart,
          __onCloseComplete = _this$props5.onCloseComplete,
          transitionOnMount = _this$props5.transitionOnMount,
          __transitionOnUpdate = _this$props5.transitionOnUpdate,
          children = _this$props5.children,
          duration = _this$props5.duration,
          Wrapper = _this$props5.Wrapper,
          rest = (0, _objectWithoutProperties2.default)(_this$props5, ["ContextProvider", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "transitionOnMount", "transitionOnUpdate", "children", "duration", "Wrapper"]);
      var _this$state = this.state,
          hidden = _this$state.hidden,
          cachedChildren = _this$state.cachedChildren,
          transitioning = _this$state.transitioning,
          transitionActive = _this$state.transitionActive,
          opening = _this$state.opening,
          closing = _this$state.closing;
      var isInitialTransitionPending = !this._isMounted && transitionOnMount;

      var renderedWrapper = _react.default.createElement(Wrapper, (0, _extends2.default)({
        duration: duration,
        hidden: hidden,
        opening: opening,
        closing: closing,
        transitioning: transitioning,
        transitionActive: transitionActive
      }, rest), children != null ? children : cachedChildren);

      return ContextProvider ? _react.default.createElement(ContextProvider, {
        value: getContextValue(transitioning || isInitialTransitionPending)
      }, renderedWrapper) : renderedWrapper;
    }
  }]);
  return TwoWayTransition;
}(_react.default.Component);

var wrapperPropTypes = {
  duration: _react.PropTypes.number,
  hidden: _react.PropTypes.bool.isRequired,
  transitioning: _react.PropTypes.bool.isRequired,
  transitionActive: _react.PropTypes.bool.isRequired,
  closing: _react.PropTypes.bool.isRequired,
  opening: _react.PropTypes.bool.isRequired
};
TwoWayTransition.propTypes = {
  children: _react.PropTypes.node,
  ContextProvider: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]),
  duration: _react.PropTypes.number.isRequired,
  onCloseComplete: _react.PropTypes.func,
  onCloseStart: _react.PropTypes.func,
  onOpenComplete: _react.PropTypes.func,
  onOpenStart: _react.PropTypes.func,
  transitionOnMount: _react.PropTypes.bool.isRequired,
  transitionOnUpdate: _react.PropTypes.bool.isRequired,
  Wrapper: RenderProps.getPropType({
    propTypes: {
      wrapperPropTypes: wrapperPropTypes
    }
  }).isRequired
};
TwoWayTransition.defaultProps = {
  children: null,
  transitionOnMount: false,
  transitionOnUpdate: true
};
TwoWayTransition.displayName = 'TwoWayTransition';

var PlainWrapper = function PlainWrapper(props) {
  var __duration = props.duration,
      __hidden = props.hidden,
      __transitioning = props.transitioning,
      __transitionActive = props.transitionActive,
      __opening = props.opening,
      __closing = props.closing,
      rest = (0, _objectWithoutProperties2.default)(props, ["duration", "hidden", "transitioning", "transitionActive", "opening", "closing"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    "data-transition-wrapper": true
  }, rest));
};

PlainWrapper.displayName = 'TwoWayTransition.PlainWrapper';
TwoWayTransition.PlainWrapper = PlainWrapper;
var _default = TwoWayTransition;
exports.default = _default;
module.exports = exports.default;